import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, input, output, signal } from '@angular/core';

import { I18nModule } from '@spartacus/core';
import { KeyboardFocusModule } from '@spartacus/storefront';

import { DpActiveFacetsComponent } from '@app-modules/product/product-facet-navigation/active-facets';
import { DpActiveFacetByCategoryPipe } from '@app-modules/product/product-facet-navigation/pipes/active-facet-by-category.pipe';

import { DpFacetCategoryComponent } from '../facet-category';
import { DpProductFacetService } from '../services';

@Component({
    selector: 'dp-facet-category-list',
    templateUrl: './facet-category-list.component.html',
    styleUrls: ['./facet-category-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        AsyncPipe,
        I18nModule,
        KeyboardFocusModule,
        DpFacetCategoryComponent,
        DpActiveFacetsComponent,
        DpActiveFacetByCategoryPipe,
        NgClass
    ]
})
export class DpFacetCategoryListComponent {
  showAllFilters = input<boolean>(false);
  exceededFilters = output<boolean>();
  facetCategoryList$ = inject(DpProductFacetService).facetCategoryList$;
  readonly #exceededActiveCategories = signal<string[]>([]);

  constructor() {
    effect(() => this.exceededFilters.emit(!!this.#exceededActiveCategories().length));
  }

  onExceeded(categoryCode: string, exceeded: boolean): void {
    this.#exceededActiveCategories.update((state) =>
      exceeded ? Array.from(new Set([...state, categoryCode])) : state.filter((item) => item !== categoryCode)
    );
  }
}
